import { createSelector } from 'reselect';
import { ormEntities, sessionSelector, createOrmSelector, OrmSelector } from "store/entities/selectors";
import { FacebookUserObject } from "store/entities/FacebookUser/types";

import { UserObject } from "./types";

export const get: OrmSelector<UserObject> = createOrmSelector(ormEntities.User);
export const getFacebookUsers: OrmSelector<FacebookUserObject[]> = createOrmSelector(ormEntities.User.facebookUsers);

export const getInstance = createSelector(sessionSelector, (_: any, id: string) => id,
	({ User }, id) => User.withId(id)
);

export const getFacebookUserInstances = createSelector(sessionSelector, (_: any, id: string) => id,
	({ User }, id) => {
		const user = User.withId(id);
		if (!user) return null;
		// TODO GIS-4551 CHECK IF IT'S CORRECT
		const facebookUsers: (FacebookUserObject & { instagramAccounts: any[] })[] = [];
		user.facebookUsers.all().toModelArray().forEach(facebookUser => {
			facebookUsers.push({
				...facebookUser.ref,
				id: facebookUser.getId(),
				insights_user_id: facebookUser.insights_user_id,
				is_valid: facebookUser.is_valid,
				name: facebookUser.name,
				picture_url: facebookUser.picture_url,
				scope: facebookUser.scope,
				expires_at: facebookUser.expires_at,
				updated_at: facebookUser.updated_at,
				instagramAccounts: facebookUser.instagramAccounts.toRefArray()
			});
		});
		return facebookUsers;
	}
);

export default {
	get,
	getFacebookUsers,
	getInstance,
	getFacebookUserInstances
};
